export const ModalChangeNicknameTranslationsEn = {
  changeNickname: 'Change nickname',
  Nickname: 'Nickname',
  saveButton: 'Save',
};
